import { Tooltip } from '@sobrus-com/sobrus-design-system-v2';
import { useTranslation } from 'react-i18next';

const GlovalTooltip = () => {
  const { t } = useTranslation();
  return (
    <>
      <Tooltip
        content={t(
          'This product cannot be activated because it is not supported by Glovo at the moment',
        )}
        id={'golovo-restriction-tooltip'}
        place='top'
      ></Tooltip>
      <Tooltip
        content={t('Compared to the last period')}
        id={'tooltip-compared-to-last-period'}
      ></Tooltip>
    </>
  );
};

export default GlovalTooltip;
